/**
 * Error Handler Service
 * Hata mesajlarını temizleme ve formatlama için merkezi service
 */

export interface ErrorResponse {
  error?: string;
  message?: string;
  errors?: Record<string, string[]>;
}

export class ErrorHandlerService {
  /**
   * API hata mesajını temizle ve kullanıcı dostu hale getir
   */
  static cleanErrorMessage(error: unknown, defaultMessage: string): string {
    if (error instanceof Error) {
      return this.cleanErrorString(error.message, defaultMessage);
    }

    if (typeof error === 'string') {
      return this.cleanErrorString(error, defaultMessage);
    }

    return defaultMessage;
  }

  /**
   * Hata string'ini temizle
   */
  static cleanErrorString(errorMessage: string, defaultMessage: string): string {
    // Eğer mesaj zaten temiz bir string ise direkt döndür
    if (!errorMessage.includes('{') && !errorMessage.includes('API error:')) {
      return errorMessage;
    }

    // JSON parse etmeye çalış
    try {
      // "API error: 422 - {...}" formatındaki mesajları temizle
      const jsonMatch = errorMessage.match(/\{[\s\S]*\}/);
      if (jsonMatch) {
        const errorData = JSON.parse(jsonMatch[0]) as ErrorResponse;

        // Validation errors varsa ilk hatayı göster
        if (errorData.errors && Object.keys(errorData.errors).length > 0) {
          const firstErrorKey = Object.keys(errorData.errors)[0];
          const firstError = Array.isArray(errorData.errors[firstErrorKey])
            ? errorData.errors[firstErrorKey][0]
            : errorData.errors[firstErrorKey];
          return firstError || errorData.message || errorData.error || defaultMessage;
        }

        // Sadece message veya error kısmını döndür
        return errorData.message || errorData.error || defaultMessage;
      }

      // JSON bulunamazsa, " - " sonrasındaki kısmı al
      if (errorMessage.includes(' - ')) {
        return errorMessage.split(' - ').pop() || defaultMessage;
      }
    } catch {
      // JSON parse edilemezse, " - " sonrasındaki kısmı al veya orijinal mesajı döndür
      if (errorMessage.includes(' - ')) {
        return errorMessage.split(' - ').pop() || defaultMessage;
      }
    }

    return errorMessage || defaultMessage;
  }

  /**
   * API response'dan hata mesajını çıkar
   */
  static extractErrorFromResponse(response: ErrorResponse, defaultMessage: string): string {
    // Validation errors varsa ilk hatayı göster
    if (response.errors && Object.keys(response.errors).length > 0) {
      const firstErrorKey = Object.keys(response.errors)[0];
      const firstError = Array.isArray(response.errors[firstErrorKey])
        ? response.errors[firstErrorKey][0]
        : response.errors[firstErrorKey];
      return firstError || response.message || response.error || defaultMessage;
    }

    // Sadece message veya error kısmını döndür
    return response.message || response.error || defaultMessage;
  }
}

